import React, {FC, useState, useEffect, useRef} from 'react'
import axios from 'axios'
import {Toast} from 'primereact/toast'
import {DataTable} from 'primereact/datatable'
import {Column} from 'primereact/column'
import {FAST_API_URL} from '../../modules/auth/core/_requests'

interface ETLJobExecutionLog {
  RunID: number
  JobName: string
  JobCategory?: string
  JobStartTime: string
  JobEndTime: string
  DurationSeconds: number
  ExecutionStatus: string
  ErrorCode?: string
  ErrorMessage?: string
  ServerName: string
  CreatedDate: string
  AdditionalInfo?: string
  path?: string
}

export const ETLLogPage: FC = () => {
  const toast = useRef<Toast>(null)
  const [etlLogs, setEtlLogs] = useState<ETLJobExecutionLog[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  // Fetch ETL job execution logs from the new table
  const fetchETLLogs = async () => {
    setLoading(true)
    try {
      // Assuming the response is of shape: { logs: ETLJobExecutionLog[] }
      const response = await axios.get<{logs: ETLJobExecutionLog[]}>(`${FAST_API_URL}/logs`)
      setEtlLogs(response.data.logs || [])
    } catch (err) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to fetch ETL logs',
      })
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchETLLogs()
  }, [])

  return (
    <div className="card text-body bg-body">
      <Toast ref={toast} />
        <div className='card-header d-flex align-items-center  pb-2 pt-2'>
          <h2 className='card-title m-0 mb-0'>ETL Job Execution Logs</h2>
        </div>
        <div className='card-body bg-body text-body mt-4'>
        <DataTable
          value={etlLogs}
          paginator
          rows={20}
          scrollable
          scrollHeight='80vh'
          rowHover
          rowsPerPageOptions={[20, 40, 100, etlLogs.length]}
          loading={loading}
          stripedRows
          sortField='CreatedDate'
          sortOrder={-1}
        >
          <Column field='RunID' header='Run ID' sortable style={{width: '50px'}} />
          <Column field='JobName' header='Job Name' sortable style={{width: '150px'}} />
          <Column field='JobCategory' header='Job Category' sortable style={{width: '80px'}} />
          <Column field='JobStartTime' header='Job Start Time' sortable style={{width: '100px'}} />
          <Column field='JobEndTime' header='Job End Time' sortable style={{width: '100px'}} />
          <Column field='DurationSeconds' header='Duration (s)' sortable style={{width: '60px'}} />
          <Column
            field='ExecutionStatus'
            header='Execution Status'
            sortable
            style={{width: '150px'}}
          />
          <Column field='ErrorCode' header='Error Code' sortable style={{width: '100px'}} />
          <Column field='ErrorMessage' header='Error Message' sortable style={{width: '200px'}} />
          <Column field='ServerName' header='Server Name' sortable style={{width: '150px'}} />
          <Column field='CreatedDate' header='Created Date' sortable style={{width: '150px'}} />
          <Column
            field='AdditionalInfo'
            header='Additional Info'
            sortable
            style={{width: '350px'}}
          />
          <Column field='path' header='Path' sortable style={{width: '200px'}} />
        </DataTable>
      </div>
    </div>
  )
}
